'use client';

import { Box, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import ProductCard from '@/_components/Card';
import { IDiscount } from '@/_types';
import { RefObject } from 'react';
import { Section } from '../utils';

interface SectionsViewProps {
  sections: Section[];
  sectionRefs: RefObject<Record<string, HTMLDivElement | null>>;
  emptyText: string;
}

export default function SectionsView({
  sections,
  sectionRefs,
  emptyText,
}: SectionsViewProps) {
  if (sections.length === 0) {
    return (
      <Box
        py={20}
        textAlign='center'
        border='1px dashed'
        borderColor='border'
        rounded={16}
      >
        <Text color='text.muted'>{emptyText}</Text>
      </Box>
    );
  }

  return (
    <VStack align='stretch' gap={10}>
      {sections.map((section) => (
        <VStack
          key={section.id}
          align='stretch'
          gap={4}
          ref={(node) => {
            sectionRefs.current[section.id] = node;
          }}
          id={section.slug}
          data-section-id={section.id}
        >
          <Text fontSize='2xl' fontWeight={700} id={section.id}>
            {section.title}
          </Text>
          <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} gap={4}>
            {section.products.map((product) => (
              <ProductCard
                product={product}
                discounts={[] as IDiscount[]}
                category={null}
                key={`${section.id}-${product.id}-${product.image}`}
              />
            ))}
          </SimpleGrid>
        </VStack>
      ))}
    </VStack>
  );
}
